import {ScreenRegion} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/layout/Perspective';
import {
    Section,
    SectionRun,
    SectionVisibility
} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {OnResizeEventFn, Resizer, ResizerProps} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {
    SectionBorderSide,
    SectionView,
    SectionViewProps
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/SectionView';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SectionRunView.less');
const cx = classnames.bind(styles);

export type OnSectionResizedFn = (run:SectionRun,
                                  section:Section,
                                  isVertical:boolean,
                                  sectionBeforeResizer,
                                  sectionAfterResizer) => (OnResizeEventFn);

export interface SectionRunViewProps extends PanelContentProps
{
    className?:string;
    run:SectionRun;
    onSectionResized:OnSectionResizedFn;
}

@observer
export class SectionRunView extends React.Component<SectionRunViewProps, any>
{
    render()
    {
        const {run, className} = this.props;
        const isInHorizontalRun = run.isHorizontal;

        const sections:Section[] = run.sections;

        const style:any = {};
        style.display = 'flex';
        style.flexDirection = isInHorizontalRun ? 'row' : 'column';

        const elements:React.ReactElement<any>[] = [];
        const numSections = sections.length;

        const pc = controllers.ui.perspective;
        const activePerspective = pc.getActivePerspective();

        if( !activePerspective )
            return null;

        const isThisRunInActivePerspective = activePerspective.hasSectionRun(run);

        for( let i = 0; i < numSections; i++ )
        {
            const section = sections[i];

            const notLast = i < numSections - 1;
            const isSectionVisible = SectionVisibility.Visible.isEqualTo(section.visibility);

            const props:SectionViewProps = {
                key: section.id,
                isVisible: isSectionVisible,
                section: section,
                onPanelResize: this.props.onPanelResize,
                onSectionResized: this.props.onSectionResized,
                borderSide: isInHorizontalRun ?
                    (notLast ? SectionBorderSide.East : SectionBorderSide.None) :
                    (notLast ? SectionBorderSide.South : SectionBorderSide.None)
            };

            elements.push(React.createElement(SectionView, props));

            let isResizerVisible = isThisRunInActivePerspective && pc.isAreActivePanelsVisible()
                || !isThisRunInActivePerspective;

            if( i < numSections - 1 )
            {
                const sectionBeforeResizer = sections[i];
                const sectionAfterResizer = sections[i + 1];

                const isSectionBeforeResizerInWest = activePerspective.isSectionInRegion(sectionBeforeResizer, ScreenRegion.West);
                const isSectionAfterResizerInEast = activePerspective.isSectionInRegion(sectionAfterResizer, ScreenRegion.East);

                const isSectionBeforeResizerVisible = SectionVisibility.Visible.isEqualTo(sectionBeforeResizer.visibility);
                const isSectionAfterResizerVisible = SectionVisibility.Visible.isEqualTo(sectionAfterResizer.visibility);

                if( (isSectionBeforeResizerInWest && !isSectionBeforeResizerVisible) ||
                    (isSectionAfterResizerInEast && !isSectionAfterResizerVisible) )
                {
                    isResizerVisible = false;
                }

                const props2:ResizerProps = {
                    key: IdUtil.newGUID(),
                    isVisible: isResizerVisible,
                    isVertical: isInHorizontalRun,
                    onResize: this.props.onSectionResized(this.props.run, section, isInHorizontalRun, sectionBeforeResizer, sectionAfterResizer)
                };

                elements.push(React.createElement(Resizer, props2));
            }
        }

        return (
            <div className={cx('sectionRun', className)} style={style}>
                {elements}
            </div>
        );
    }
}




